export default {
  addShopSuccess: 'Przedmiot dodany pomyślnie',
  addShopFail: 'Nie udało się dodać przedmiotu',
  getCartDataFail: 'Nie udało się pobrać koszyka',
  hint: 'Wskazówka',
  delConfirmProduct: 'Czy na pewno chcesz usunąć ten przedmiot?',
  confirm: 'Potwierdź',
  cancel: 'Anuluj',
  productInfo: 'Szczegóły przedmiotu',
  unitPrice: 'Cena za sztukę',
  num: 'Ilość',
  subtotal: 'Łącznie',
  action: 'Akcja',
  productName: 'Nazwa przedmiotu',
  splitProduct: 'Podziel przedmiot',
  split: 'Podziel',
  allSelect: 'Wybierz wszystkie',
  delProduct: 'Usuń zaznaczone',
  selected: 'Zaznaczone',
  piece: 'Przedmiot(y)',
  total: 'Łącznie',
  productTotal: 'Bez opłat za dostawę międzynarodową',
  orderPay: 'Zapłać',
  orderTotal: 'Łącznie',
  goCartPay: 'Zobacz koszyk',
  moreView: 'Więcej przedmiotów w koszyku',
  noSelectText: "Nie wybrano żadnych przedmiotów",
  paySuccess: 'Płatność przeszła pomyślnie!',
  returnPayment: 'Powrót do płatności',
  service: 'Usługa',
  goodsMinNumErrTips:
    'Ten przedmiot wymaga zakupu minimum {num} sztuk, możesz wybrać różne wersje.',
  balckShop: 'Sklep został zablokowany',
  forbidBuy: 'Ryzykowny sklep, zakupy wstrzymane',
  riskTip: 'Ryzykowny sklep, uważaj podczas zakupu',
  riskReminder: 'Przypomnienie o ryzyku',
  blackenedShop: 'zablokowany sklep',
  riskProducts: 'Ryzykowne przedmioty',
  riskMsg1:
    'Ten przedmiot może być ryzykowny. Dla twojego bezpieczeństwa nie możemy obecnie go zamówić. Jeśli chcesz się dowiedzieć więcej, skontaktuj się z naszą obslugą klienta.',
  riskMsg2:
    'Dostawa tego przedmiotu może być ryzykowna. Dla twojego bezpieczeństwa nie możemy obecnie go zamówić. Jeśli chcesz się dowiedzieć więcej, skontaktuj się z naszą obslugą klienta',
  riskMsg3:
    'Przedmiot może być markowy lub specjalny. Nie możemy go zweryfikować, możemy tylko zapewnić zakup i podstawową kontrolę jakości. Musisz ponieść to ryzyko.',
  continueToBuy: 'Kontynuuj zakupy innych przedmiotów',
  buyOthers: 'Kup podobne',
  continuePurchasing: 'Kontynuuj zakupy'
};
